/* eslint-disable no-param-reassign */
import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "store";
import { PaginatedRoomsInfo, RoomEntity } from "types/rooms";

export interface RoomsState {
  paginatedRoomsInfo: PaginatedRoomsInfo | null;
  currentRoom: RoomEntity | null;
  isLoadingRooms: boolean;
  isLoadingRoom: boolean;
}

export const roomsInitialState: RoomsState = {
  paginatedRoomsInfo: null,
  currentRoom: null,
  isLoadingRooms: false,
  isLoadingRoom: false,
};

const slice = createSlice({
  name: "Rooms",
  initialState: roomsInitialState,
  reducers: {
    setRooms: (state, action: PayloadAction<PaginatedRoomsInfo>) => {
      state.paginatedRoomsInfo = action.payload;
    },
    setCurrentRoom: (state, action: PayloadAction<RoomEntity>) => {
      state.currentRoom = action.payload;
    },
    setRoomsLoading: (state) => {
      state.isLoadingRooms = true;
    },
    setEndRoomsLoading: (state) => {
      state.isLoadingRooms = false;
    },
    setRoomLoading: (state) => {
      state.isLoadingRoom = true;
    },
    setEndRoomLoading: (state) => {
      state.isLoadingRoom = false;
    },
  },
});

export const {
  setEndRoomLoading,
  setEndRoomsLoading,
  setRoomLoading,
  setRoomsLoading,
  setRooms,
  setCurrentRoom,
} = slice.actions;

export const getSpacesSelector = createSelector(
  (state: RootState) => state.spaceState,
  (state) => state.spaces,
);

export default slice.reducer;
